// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P48s","colBig":"styles_colBig__11ge1","colSmall":"styles_colSmall__1a9dF"};